
import UpdateAudioFileCategoryRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MusicService/UpdateAudioFileCategoryRequest";
import TranslationModel from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/TranslationModel";
import Vue from "vue"
import { Component, Prop, Watch } from "vue-property-decorator"

@Component
export default class CreateMusicCategoryPage extends Vue {
    get title(): string {
        return this.id ? 'Редактирование категории музыки': 'Добавление категории музыки';
    }
    get id(): number {
        if (!this.$route.params.id) {
            return 0;
        }
        return Number(this.$route.params.id);
    }
    isLoading = false;
    request = new UpdateAudioFileCategoryRequest({
        Id: 0,
        Translations: []
    });
    async fetchData() {
        this.isLoading = true;
        try {
            const res = await this.$api.MusicService.getCategoryAsync(this.id);
            this.request.Id = res.Id;
            (res.Translations || []).forEach((serverTranslation) => {
                let translation = this.request.Translations.find(
                    (item) => item.LangCode === serverTranslation.LangCode
                );
                if (!translation) {
                    translation = new TranslationModel({
                        LangCode: serverTranslation.LangCode,
                        Name: ''
                    });
                    this.request.Translations.push(translation);
                }
                translation.Name = serverTranslation.Name;
            });
        } catch (error) {
            this.$notification.error(error);
        } finally {
            this.isLoading = false;
        }
    }
    async created() {
        const langs = await this.$cacheProvider.getLanguagesAsync();
        this.request.Translations = (langs || []).map((x: string) => 
            new TranslationModel({
                LangCode: x,
                Name: ''
            }));
        if (this.$route.params.id) {
            await this.fetchData();
        }
    }
    async add() {
        const translations = (this.request.Translations || [])
            .filter((item) => Boolean((item.Name || '').trim()))
            .map((item) => new TranslationModel({
                LangCode: item.LangCode,
                Name: item.Name.trim()
            }));
        if (!translations.length) {
            this.$notification.error("Заполните хотя бы один перевод");
            return;
        }
        var valid = (this.$refs.validator as any).isValid();
        if (!valid) {
            return;
        }
        this.isLoading = true;
        try {
            const result = await this.$api.MusicService.updateCategoryAsync(
                new UpdateAudioFileCategoryRequest({
                    Id: this.request.Id,
                    Translations: translations
                })
            );
            if (result) {
                this.$dialog.success(
                    this.id
                        ? 'Категория успешно обновлена'
                        : 'Категория успешно добавлена'
                );
                this.$router.back();
            }
        } catch (error) {
            this.$notification.error(error);
        } finally {
            this.isLoading = false;
        }
    }
}
